module.exports = __webpack_public_path__ + "img/rdsc_icon_left.f8cfe989.png";